import { intercept } from 'mobx';
import { inject, observer } from 'mobx-react';
import * as React from 'react';
import { Prompt, Redirect } from 'react-router';
import { Button, Col, FormGroup, Input, Label, Row } from 'reactstrap';
import { IRegion } from 'src/Interfaces/WellInterface';
import { AdminStore } from 'src/Stores/Admin/AdminStore';
import { UserStore } from 'src/Stores/User/UserStore';
import { allOrNoneSelected } from 'src/UtilityFunctions/SelectAllOrNone';
import { ICategory } from '../../../../Interfaces/AdminInterface';
import { IProduct } from '../../../../Interfaces/TestInterface';
import DataService from '../../../../Services/Data';
import ButtonRow from '../../../ButtonRow';
import { EButton, EInput } from '../../../EInput';




@inject('stores')
@observer
class AdminProductDetails extends React.Component {

    public props: any;
    public dataService: any = new DataService();
    public product: IProduct = new IProduct();
    public categories: ICategory[] = [];
    public selectedCategorys: any[] = [];
    public productDisposer: any;
    public categoryDisposer: any;
    public tentantDisposer: any;
    public adminStore: AdminStore;
    public MessageStore: any;
    public ErrorStore: any;
    public UserStore: UserStore;

    public state = {
        categories: this.categories,
        isDirty: false,
        primaryCategoryId: 0,
        product: this.product,
        productId: '',
        redirect: false,
        regions: [] as IRegion[],
        selectedCategorys: this.selectedCategorys,
        selectedRegions: [] as boolean[],
    };

    constructor(props: any) {
        super(props);

        this.adminStore = this.props.stores.AdminStore;
        this.MessageStore = this.props.stores.MessageStore;
        this.ErrorStore = this.props.stores.ErrorsStore;
        this.UserStore = this.props.stores.UserStore;

        this.handleChange = this.handleChange.bind(this);
        this.handleSaveProduct = this.handleSaveProduct.bind(this);
        this.handleCategorySelect = this.handleCategorySelect.bind(this);
        this.markCategoryPrimary = this.markCategoryPrimary.bind(this);
        this.isPrimarySelected = this.isPrimarySelected.bind(this);
        this.removeProduct = this.removeProduct.bind(this);
    }

    public componentDidMount() {
        this.createDisposers();

        this.adminStore.getCategories();
        this.adminStore.getRegions()
            .then(regions => {
                this.setState({
                    productId: this.props.match.params.id,
                    regions,
                    selectedCategorys: [],
                }, () => {
                    if ( this.state.productId !== 'new' ) {
                        this.adminStore.getProduct(this.props.match.params.id);
                    }
                });
        });
    }

    public componentWillUnmount() {
        this.clearDisposers();
    }

    public createDisposers() {
        this.categoryDisposer = intercept(this.adminStore, 'categories', (change: any) => {
            this.setState({
                categories: change.newValue,
            });

            return change;
        });

        this.productDisposer = intercept(this.adminStore, 'product', (change: any) => {
            this.setState({
                product: change.newValue,
                selectedCategorys: [],
            }, () => {
                this.parseProductCategorys();
                this.setSelectedRegions();
            });

            return change;
        });
    }

    public clearDisposers() {
        this.productDisposer();
        this.categoryDisposer();
    }

    private setSelectedRegions = () => {
        const product = this.state.product;
        const regions = this.state.regions;
        const selectedRegions = this.state.selectedRegions;
        regions.forEach((region, index) => {
            if (product.regions.some(reg => reg.id === region.id))
            {
                selectedRegions[index] = true;
            } else {
                selectedRegions[index] = false;
            }
        });
    }
    public handleChange(event: any) {
        const product = this.state.product;

        if ( event.target.type === 'checkbox' ) {
            const val = product[event.target.name];
            const newVal = (val === '') ? true : !val;
            product[event.target.name] = newVal;
        } else {
            product[event.target.name] = event.target.value;
        }

        this.setState({
            isDirty: true,
            product
        });
    }

    public handleCategorySelect(event: any) {
        event.persist();

        const product = this.state.product;
        const newCategories: any[] = [];
        const selecteds: any[] = [];

        for ( const option of event.target.options) {
            if ( option && option.selected ) {
                selecteds.push(option.value);

                const filtered = this.dataService.search(this.state.categories, option.value, ['id']);
                
                if ( filtered.length > 0 ) {
                    newCategories.push(filtered[0]);
                }
            }
        }
        if (newCategories.length === 1) {
            newCategories[0].isPrimary = true;
        }
        product.categorys = newCategories;
        this.setState({
            isDirty: true,
            product,
            selectedCategorys: selecteds
        });
    }

    public handleRegionSelect = (index: number) => (event: any) => {
        const selectedRegions = this.state.selectedRegions;
        selectedRegions[index] = !selectedRegions[index];
        this.setState({selectedRegions});
    }

    public parseProductCategorys() {
        const categorys: any[] = this.state.product.categorys;
        const strippedCategorys: any[] = [];

        categorys.map((category: ICategory) => {
            strippedCategorys.push(category.id);
        });

        this.setState({
            selectedCategorys: strippedCategorys
        });
    }

    public handleSaveProduct() {
        const product = this.state.product;
        const regions = this.state.regions;
        const selectedRegions = this.state.selectedRegions;
        product.regions = [];
        regions.forEach((region, index) => {
            if(selectedRegions[index] === true)
            {
                product.regions.push(region);
            }
        });
        this.adminStore.saveProduct(product)
            .then(
                (data: any) => {
                    if (data) {
                        this.setState({
                            redirect: true
                        });
                        let message = 'Changes have been saved';

                        if ( this.state.productId === 'new' ) {
                            message = 'Product has been saved and created';
                        }
                        this.MessageStore.addMessage(
                            message,
                            'success'
                        );
                    }
                },
                (error: any) => {
                    this.MessageStore.addMessage(
                        error.toString(),
                        'danger'
                    );
                }
            );
    }

    public markCategoryPrimary = (category: any) => (event: any) => {
        event.persist();

        const value: any = event.target.value;
        const product: IProduct = this.state.product;
        const cats: any = product.categorys;
        const selecteds: any[] = [];
        
        event.target.checked = !event.target.checked;

        cats.forEach((cat: any, index: number) => {
            if ( cat.id === value) {
                cat.isPrimary = true;
            } else {
                cat.isPrimary = false;
            }

            selecteds.push(cat.id);
        });

        product.categorys = cats;
        this.setState({
            isDirty: true,
            product,
            selectedCategorys: selecteds,
        });
    }

    public renderRegionCheckBox = (region: IRegion, index: number) => {
        const checked = this.state.selectedRegions;
        return (
            <FormGroup key={region.id}>
                <Label check={true}>
                    <Input
                        type="checkbox"
                        checked={checked[index]}
                        onChange={this.handleRegionSelect(index)}
                        />
                    {region.name}
                </Label>
            </FormGroup>
        );
    }

    public listSelectedCategorys() {
        const selecteds: any[] = this.state.selectedCategorys;
        let selected: any[] = [];

        selecteds.map((category: ICategory, index: number) => {
            const cFiltered: ICategory[] = this.dataService.search(this.state.categories, category, ['id']);
            const pFiltered: any[] = this.dataService.search(this.state.product.categorys, category, ['id']);
            
            if ( cFiltered.length > 0 && pFiltered.length > 0 ) {
                selected.push({
                    id: cFiltered[0].id,
                    isPrimary: pFiltered[0].isPrimary,
                    name: cFiltered[0].name,
                });

            } else {
                selected.push({
                    id: 0,
                    isPrimary: false,
                    name: 'Category reference not found',
                });
            }
        });

        selected = this.dataService.sort(selected, {'name': 'asc'});

        return(
            selected.map((category: any, index: number) => 
                <FormGroup check={true} key={index}>
                    <Label check={true}>
                        <EInput
                            type="radio"
                            id={'defaultCategoryId-' + category.id}
                            name="defaultCategoryId"
                            onChange={this.markCategoryPrimary(category)}
                            checked={category.isPrimary}
                            value={category.id}
                            required={true}
                        />
                        {category.name}
                    </Label>
                </FormGroup>
            )
        );
    }

    private lengthMaximum = (length: number, maximum: number) => {
        if (length > maximum) {
            return maximum;
        }
        return length;
    }
    public isPrimarySelected() {
        let thereIsAPrimary: boolean = true;

        this.state.product.categorys.map((cat: any) => {
            if ( cat.isPrimary ) {
                thereIsAPrimary = false;
            }
        });

        return thereIsAPrimary;
    }

    private selectAllOrNone = (value: boolean) => () => {
        const regions = this.state.regions;
        const selectedRegions = new Array(regions.length).fill(value);
        this.setState({selectedRegions});
    }
    private allOrNoneSelected = (value: boolean) => {
        return allOrNoneSelected(value, 'regions', 'selectedRegions', this.state);
    }
    private renderSelectionButons = () => {
        return (
            <div style={{marginBottom: '1rem'}}>
                <Button 
                    color="primary"
                    outline={!this.allOrNoneSelected(true)}
                    onClick={this.selectAllOrNone(true)}
                >
                    All
                </Button>
                {' '}
                <Button 
                    color="primary"
                    outline={!this.allOrNoneSelected(false)}
                    onClick={this.selectAllOrNone(false)}
                >
                    None
                </Button>
            </div>
        );
    }

    public removeProduct() {
        const areYouSure = confirm(
        `Deleting this Product will not affect any Wells/Well`
        + ` Tests that this Product exists on, however, it will remove it from all Price Lists.\n\n`
        + `Are you sure you want to remove Product: ${this.state.product.name}?\n\n`
        + `Press OK to delete.`
        );

        if (areYouSure) {
            this.adminStore.deleteProduct(this.state.product)
                .then(
                    (data: any) => {
                        if (data) {
                            this.setState({
                            redirect: true
                            });
    
                            this.MessageStore.addMessage(
                                'Product Successfully Deleted',
                                'success'
                            );
                        }
                    }
                );
        }
    }

    public render() {
        return(
            this.state.redirect ? (
                <Redirect to="/admin/products" />
            ) : (
                <div>
                    <Prompt when={this.state.isDirty} message={"Changes have been made.\n\nPress Cancel then Press Save OR Press OK to continue without saving."} />
                    <Row className="header">
                        <Col md="12">
                            {this.state.productId === 'new' ? (
                                <h2 className="float-left">Add New Product</h2>
                            ) : (
                                <h2 className="float-left">Product Detail for {this.state.product.name}</h2>
                            )}
                        </Col>
                    </Row>
                    <Row>
                        <Col md="4">
                            <FormGroup className="required">
                                <Label>Name</Label>
                                <EInput
                                    type="text"
                                    name="name"
                                    required={true}
                                    value={this.state.product.name}
                                    onChange={this.handleChange}
                                    disabled={this.state.product.id !== ''}
                                />
                            </FormGroup>
                            <FormGroup>
                                <Label>Erp Id</Label>
                                <EInput
                                    type="text"
                                    name="erpId"
                                    value={this.state.product.erpId}
                                    onChange={this.handleChange}
                                />
                            </FormGroup>
                            <FormGroup className="required">
                                <Label>Unit Size</Label>
                                <EInput
                                    type="text"
                                    name="size"
                                    value={this.state.product.size}
                                    onChange={this.handleChange}
                                    disabled={this.state.product.id !== ''}
                                    required={true}
                                />
                            </FormGroup>
                            <FormGroup className="required">
                                <Label>Unit of Measure</Label>
                                <EInput
                                    type="text"
                                    name="unit"
                                    value={this.state.product.unit}
                                    onChange={this.handleChange}
                                    disabled={this.state.product.id !== ''}
                                    required={true}
                                />
                            </FormGroup>
                            <FormGroup>
                                <Label>Weight</Label>
                                <EInput
                                    type="text"
                                    name="weight"
                                    value={this.state.product.weight}
                                    onChange={this.handleChange}
                                />
                            </FormGroup>
                            <FormGroup>
                                <Label>Specific Gravity</Label>
                                <EInput
                                    type="text"
                                    name="specificGravity"
                                    value={this.state.product.specificGravity}
                                    onChange={this.handleChange}
                                />
                            </FormGroup>
                            <FormGroup>
                                <Label>Retail Price</Label>
                                <EInput
                                    type="text"
                                    name="retailPrice"
                                    data-mask="currency"
                                    value={this.state.product.retailPrice}
                                    onChange={this.handleChange}
                                />
                            </FormGroup>
                            <FormGroup>
                                <Label>Cost</Label>
                                <EInput
                                    type="text"
                                    name="cost"
                                    data-mask="currency"
                                    value={this.state.product.cost}
                                    onChange={this.handleChange}
                                />
                            </FormGroup>
                            <FormGroup>
                                <Label>
                                    <EInput
                                        type="checkbox"
                                        name="isTaxable"
                                        value={this.state.product.isTaxable}
                                        checked={this.state.product.isTaxable}
                                        onChange={this.handleChange}
                                    />Is Taxable
                                </Label>
                            </FormGroup>
                            <FormGroup>
                                <Label>
                                    <EInput
                                        type="checkbox"
                                        name="isBulk"
                                        value={this.state.product.isBulk}
                                        checked={this.state.product.isBulk}
                                        onChange={this.handleChange}
                                    />Is Bulk
                                </Label>
                            </FormGroup>
                        </Col>
                        <Col md="4">
                            <FormGroup className="required">
                                <Label>Categories</Label>
                                <EInput
                                    type="select"
                                    name="selectedCategorys"
                                    multiple={true}
                                    size={this.lengthMaximum(this.state.categories.length, 35)}
                                    onChange={this.handleCategorySelect}
                                    value={this.state.selectedCategorys}
                                >
                                    {this.state.categories.map((category: ICategory, index: any) =>
                                        <option key={index} value={category.id}>{category.name}</option>
                                    )}
                                </EInput>
                            </FormGroup>
                            { this.state.selectedCategorys.length > 0 &&
                                <div style={{marginBottom: '2rem'}}>
                                    <h5>Select a Primary Category</h5>
                                    <FormGroup className="emptyFormGroup" />
                                    { (this.state.selectedCategorys.length > 0 && this.isPrimarySelected()) &&
                                        <div className="no-primary-selected">
                                            A Primary Category must be selected
                                        </div>
                                    }
                                    {this.listSelectedCategorys()}
                                </div>
                            }
                        </Col>
                        <Col md="4">
                            
                                <h4>Regions</h4>
                                {this.renderSelectionButons()}
                                <div style={{maxHeight: '65vh', overflowY: 'scroll'}}>
                                        {
                                            this.state.regions.map((region, index) => {
                                                return this.renderRegionCheckBox(region, index);
                                            })
                                        }
                                </div>
                        </Col>
                    </Row>
                    {
                        (this.state.product.id === '' ?
                        this.UserStore.hasPermission('Permissions.Admin.Inventory.Create')
                            :
                        this.UserStore.hasPermission('Permissions.Admin.Inventory.Update'))
                        &&
                        <ButtonRow>
                            <Button color="danger" onClick={this.removeProduct}>Delete Product</Button>
                            <EButton color="primary" disabled={(!(this.state.product.categorys.length > 0) || this.isPrimarySelected())} onClick={this.handleSaveProduct}>Save Product</EButton>
                        </ButtonRow>
                    }
                </div>
            )
        );
    }
}

export default AdminProductDetails;


// WEBPACK FOOTER //
// ./src/Components/Main/Admin/Products/AdminProductDetails.tsx